var styles = {"nativeCheckbox":"bc-checkbox__nativeCheckbox","icon":"bc-checkbox__icon","indeterminate":"bc-checkbox__indeterminate","disabled":"bc-checkbox__disabled","small":"bc-checkbox__small","rounded":"bc-checkbox__rounded","large":"bc-checkbox__large","xl":"bc-checkbox__xl"};

export { styles as default };
